import { all } from 'redux-saga/effects';
// import { watchBlockChanges, watchShouldPersistBlocksCheck } from './sagas/grid';
import { watchDashboardChanges, watchShouldPersistDashboardsCheck } from './sagas/dashboards';

export default function* rootSaga() {
  yield all([watchDashboardChanges(), watchShouldPersistDashboardsCheck()]);
}
